/**
 * Flexible Australian phone number pattern (with formatting)
 * Allows variable length phone numbers (1-10 digits after prefix)
 *
 * Examples:
 * - 0412345678
 * - 04 1234 5678
 * - 0 4 1 2 3 4 5 6 7 8
 * - +61412345678
 * - +61 4 1234 5678
 */
export const PHONE_NUMBER_REGEX = /^(?:\+61|0)(?:\s*\d\s*){1,10}$/;

/**
 * Strict Australian phone number pattern (with formatting)
 * Requires exactly 9 digits after the prefix
 *
 * Examples:
 * - 0412345678
 * - 04 12345678
 * - 0 412345678
 * - +61412345678
 * - +61 412345678
 * - 61412345678
 * - 61 412345678
 */
export const PHONE_NUMBER_REGEX_2 = /^(\+?61|0)(\s*\d){9}$/;

/**
 * Australian phone number validation patterns (after formatting is removed)
 *
 * These patterns validate Australian phone numbers AFTER spaces, dashes,
 * parentheses, and plus signs have been stripped out.
 */

/**
 * Australian local format: 0X XXXX XXXX (area codes 02-09, 10 digits total)
 *
 * Examples:
 * - 0212345678 (NSW landline)
 * - 0312345678 (VIC landline)
 * - 0412345678 (Mobile)
 * - 0712345678 (QLD landline)
 * - 0812345678 (WA/SA/NT landline)
 */
export const AUSTRALIAN_LOCAL_PHONE_REGEX = /^0[2-9]\d{8}$/;

/**
 * International format: 61 X XXXX XXXX (without the leading 0, 11 digits total)
 *
 * Examples:
 * - 61212345678 (NSW landline in international format)
 * - 61412345678 (Mobile in international format)
 *
 * Note: The '+' sign should be removed before validating with this pattern
 */
export const AUSTRALIAN_INTERNATIONAL_PHONE_REGEX = /^61[2-9]\d{8}$/;
